export const affiliateRegistrationStatuses = {
  new: 'new',
  rejected: 'rejected',
  approved: 'approved'
}
